import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class HorasSimpleExtras extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            numeroNombre: [],
            lugaresTra: [],
            lugarCentral: [],
            consultaRealizada: false,
            loading: false,
            consultaHSE: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                mes: '',
                anio: '',
                ubicacion: '',
                ubicacionCentral: '',
            },
            datosConsulta: [],
            menuPrincipal: true,
            tipoListado: '',
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarCambiosDatosListado = this.manejarCambiosDatosListado.bind(this);
        this.manejoEnvioConsultaTurismo = this.manejoEnvioConsultaTurismo.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });
    }
    render(){
        return (
            <>
                <Container>
                    {this.state.tipoListado === ''
                    ?
                        null
                    :
                        this.state.tipoListado === '1'
                        ?
                            <h3>HORAS SIMPLES Y EXTRAS</h3>
                        :
                            this.state.tipoListado === '2'
                            ?
                                <h3>DIAS TURISMO</h3>
                            :
                                null
                    }
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <br/>
                        <div>
                            {this.state.consultaRealizada ?
                                <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                                </ReactHtmlTableToExcel>
                            :
                                null
                            }
                        </div>
                    <br/>
                    {this.state.tipoListado === ''
                    ?
                        <Container>
                            <Box sx={{alignItems: 'center'}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>TIPO LISTADO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoListado'  value={this.state.tipoListado} onChange={this.manejarCambiosDatosListado}>
                                            <option value=''></option>
                                            <option value={1}>HORAS SIMPLES Y EXTRAS</option>
                                            <option value={2}>DIAS TURISMO</option>
                                        </select>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Container>
                    :
                        null
                    }
                    {this.state.consultaRealizada || this.state.tipoListado === ''
                    ?
                        null
                    :
                        <Container>
                            {this.state.tipoListado === '1'
                            ?
                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Número Funcionario</StyledTableCell>
                                                <StyledTableCell>Nombre</StyledTableCell>
                                                <StyledTableCell>Ubicación</StyledTableCell>
                                                {this.state.consultaHSE.ubicacion === '0' ? <StyledTableCell width={'16%'}>Ubicación Central</StyledTableCell> : null}
                                                <StyledTableCell>Mes</StyledTableCell>
                                                <StyledTableCell>Año</StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {this.state.consulta ? null :
                                            <StyledTableRow>
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.consultaHSE.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell>{this.state.consultaHSE.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacion'  value={this.state.consultaHSE.ubicacion} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>UBICACION</option>
                                                        {this.state.lugaresTra.map((name) =>
                                                            <option
                                                            key={name.idLugaresTrabajo}
                                                            value={name.idLugaresTrabajo}
                                                            >{name.lugar}</option>
                                                            )}
                                                    </select>
                                                </StyledTableCell>
                                                {this.state.consultaHSE.ubicacion === '0' ?
                                                    <StyledTableCell>
                                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.consultaHSE.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                            <option value=''>UBICACION</option>
                                                            {this.state.ubicacionesCentral.map((name) =>
                                                                <option
                                                                key={name.idUbicacionesCentral}
                                                                value={name.idUbicacionesCentral}
                                                                >{name.descripcion}
                                                            </option>
                                                                )}
                                                        </select>
                                                    </StyledTableCell> : null
                                                }
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.consultaHSE.mes} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>MES</option>
                                                        <option value={'01'}>ENERO</option>
                                                        <option value={'02'}>FEBRERO</option>
                                                        <option value={'03'}>MARZO</option>
                                                        <option value={'04'}>ABRIL</option>
                                                        <option value={'05'}>MAYO</option>
                                                        <option value={'06'}>JUNIO</option>
                                                        <option value={'07'}>JULIO</option>
                                                        <option value={'08'}>AGOSTO</option>
                                                        <option value={'09'}>SETIEMBRE</option>
                                                        <option value={'10'}>OCTUBRE</option>
                                                        <option value={'11'}>NOVIEMBRE</option>
                                                        <option value={'12'}>DICIEMBRE</option>
                                                    </select>
                                                </StyledTableCell>
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='anio' value={this.state.consultaHSE.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                            </StyledTableRow>
                                        }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            :
                                this.state.tipoListado === '2'
                                ?
                                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                        <Table sx={{minWidth: 700}}>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>Número Funcionario</StyledTableCell>
                                                    <StyledTableCell>Nombre</StyledTableCell>
                                                    <StyledTableCell>Ubicación</StyledTableCell>
                                                    {this.state.consultaHSE.ubicacion === '0' ? <StyledTableCell width={'16%'}>Ubicación Central</StyledTableCell> : null}
                                                    <StyledTableCell>Año</StyledTableCell>
                                                    <StyledTableCell></StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {this.state.consulta ? null :
                                                <StyledTableRow>
                                                    <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.consultaHSE.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                    <StyledTableCell>{this.state.consultaHSE.nombreFuncionario}</StyledTableCell>
                                                    <StyledTableCell>
                                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacion'  value={this.state.consultaHSE.ubicacion} onChange={this.manejarCambiosDatos}>
                                                            <option value=''>UBICACION</option>
                                                            {this.state.lugaresTra.map((name) =>
                                                                <option
                                                                key={name.idLugaresTrabajo}
                                                                value={name.idLugaresTrabajo}
                                                                >{name.lugar}</option>
                                                                )}
                                                        </select>
                                                    </StyledTableCell>
                                                    {this.state.consultaHSE.ubicacion === '0' ?
                                                        <StyledTableCell>
                                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.consultaHSE.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                                <option value=''>UBICACION</option>
                                                                {this.state.ubicacionesCentral.map((name) =>
                                                                    <option
                                                                    key={name.idUbicacionesCentral}
                                                                    value={name.idUbicacionesCentral}
                                                                    >{name.descripcion}
                                                                </option>
                                                                    )}
                                                            </select>
                                                        </StyledTableCell> : null
                                                    }
                                                    <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='anio' value={this.state.consultaHSE.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                    <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsultaTurismo()}>Consultar</button></StyledTableCell>
                                                </StyledTableRow>
                                            }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                :
                                    null
                            }
                        </Container>
                    }
                    {this.state.consultaRealizada && (this.state.tipoListado !== '' && this.state.tipoListado === '1')
                    ?
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                    <StyledTableCell align="center" colSpan={9}>
                                        HORAS SIMPLES Y EXTRAS - {this.state.datosConsulta[0].mes} {this.state.datosConsulta[0].anio}
                                    </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>N. Funcionario</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Horario</StyledTableCell>
                                        <StyledTableCell>Fecha</StyledTableCell>
                                        <StyledTableCell>Entrada</StyledTableCell>
                                        <StyledTableCell>Salida</StyledTableCell>
                                        <StyledTableCell>HS. Simples</StyledTableCell>
                                        <StyledTableCell>HS. Extras</StyledTableCell>
                                        <StyledTableCell>Descanso Trabajado</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.datosConsulta.map((name, index) => (
                                        <StyledTableRow key={index}>
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.numeroFuncionario}</StyledTableCell> : <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>}
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.nombreFuncionario}</StyledTableCell> : <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>}
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.horario}</StyledTableCell> : <StyledTableCell>{name.horario}</StyledTableCell>}
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.fecha}</StyledTableCell> : <StyledTableCell>{name.fecha}</StyledTableCell>}
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.horaEntrada}</StyledTableCell> : <StyledTableCell>{name.horaEntrada}</StyledTableCell>}
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.horaSalida}</StyledTableCell> : <StyledTableCell>{name.horaSalida}</StyledTableCell>}
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.horasSimples}</StyledTableCell> : <StyledTableCell>{name.horasSimples}</StyledTableCell>}
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.horasExtras}</StyledTableCell> : <StyledTableCell>{name.horasExtras}</StyledTableCell>}
                                            {name.feriado ? <StyledTableCell style={{color: 'red'}}>{name.horasDescanso}</StyledTableCell> : <StyledTableCell>{name.horasDescanso}</StyledTableCell>}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    :
                        null
                    }
                    {this.state.consultaRealizada  && (this.state.tipoListado !== '' && this.state.tipoListado === '2')
                    ?
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                    <StyledTableCell align="center" colSpan={3}>
                                        DIAS TURISMO - {this.state.consultaHSE.anio}
                                    </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>N. Funcionario</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Días Generados</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.datosConsulta.map((name, index) => (
                                        <StyledTableRow key={index}>
                                            <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{name.totalDias}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    :
                        null
                    }
                    {this.state.consultaRealizada ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : ''}
                </Container>
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            consultaRealizada: false,
        });
        this.setState(state => {
            const numFunActualizado = state.consultaHSE;
            numFunActualizado[clave] = valor;
            
            if((clave === 'numeroFuncionario') && (valor !== '') ){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'nombreFuncionario') && (valor === '')){
                numFunActualizado['nombreFuncionario'] = '';
            }
            
            return{
                consultaHSE: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
        })
        if((this.state.consultaHSE.numeroFuncionario !== '') && (this.state.consultaHSE.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }else if(this.state.consultaHSE.mes === ''){
            this.setState({
                errores: 'Debe ingresar el mes de la consulta',
            })
        }else if(this.state.consultaHSE.anio === ''){
            this.setState({
                errores: 'Debe ingresar el año de la consulta',
            })
        }else{
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.consultaHSE, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/calcular_horasSimplesExtras.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
            })
            if(exito[0] === 'ok'){
                this.setState({
                    datosConsulta: exito[1],
                    consultaRealizada: true,
                    loading: false,
                    errores: null,
                })
            }else{
                this.setState({
                    loading: false,
                    errores: null,
                })
            }
        }
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consultaRealizada: false,
            loading: false,
            consultaHSE: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                mes: '',
                anio: '',
                ubicacion: '',
                ubicacionCentral: '',
            },
            datosConsulta: [],
        });
    }

    manejarCambiosDatosListado(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            consultaRealizada: false,
            tipoListado: valor,
        });
    }

    async manejoEnvioConsultaTurismo(){
        this.setState({
            errores: null,
            notificaciones: null,
        })
        if((this.state.consultaHSE.numeroFuncionario !== '') && (this.state.consultaHSE.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }else if(this.state.consultaHSE.anio === ''){
            this.setState({
                errores: 'Debe ingresar el año de la consulta',
            })
        }else{
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.consultaHSE, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/calcular_diasTurismo.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
                loading: false,
                datosConsulta: exito[1],
            })
            if(exito[0] === 'ok'){
                this.setState({
                    datosConsulta: exito[1],
                    consultaRealizada: true,
                    loading: false,
                    errores: null,
                })
            }
        }
    }
}

export default HorasSimpleExtras